import PropTypes from 'prop-types';
import React from 'react';

import * as ExportConstants from 'constants/ExportConstants';
import {Snapshot} from 'notebook/reviews/ReviewConstants';
import BenchlingIcon, {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';
import {RelativeTime} from 'ui-library/Times';

const SNAPSHOT_PROPS = PropTypes.shape({
  status: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired,
  url: PropTypes.string,
});

function SnapshotText({snapshot}: {snapshot: Snapshot}): JSX.Element {
  const {STATUS} = ExportConstants;
  switch (snapshot.status) {
    case STATUS.PENDING:
    case STATUS.RUNNING:
      return (
        <span>
          Entry snapshot started <RelativeTime datetime={snapshot.createdAt} />.
        </span>
      );
    case STATUS.FAILED:
      return <span>Entry snapshot failed.</span>;
    case STATUS.SUCCEEDED:
      return (
        <span>
          Entry snapshot succeeded <RelativeTime datetime={snapshot.createdAt} />.
        </span>
      );
    default:
      throw new Error(`Unexpected snapshot status ${snapshot.status}`);
  }
}

SnapshotText.propTypes = {
  snapshot: SNAPSHOT_PROPS.isRequired,
};

const STATUS_TO_ICON: Record<string, BenchlingIconName> = {
  [ExportConstants.STATUS.PENDING]: 'request-in-progress',
  [ExportConstants.STATUS.RUNNING]: 'request-in-progress',
  [ExportConstants.STATUS.FAILED]: 'request-failed',
  [ExportConstants.STATUS.SUCCEEDED]: 'download',
};

function SnapshotIcon({snapshot, className}: {snapshot: Snapshot; className?: string}): JSX.Element {
  const icon = STATUS_TO_ICON[snapshot.status];
  return <BenchlingIcon icon={icon} className={className} />;
}

SnapshotIcon.propTypes = {
  snapshot: SNAPSHOT_PROPS.isRequired,
  className: PropTypes.string.isRequired,
};

export default function SnapshotInfo({snapshot}: {snapshot: Snapshot}): JSX.Element {
  const snapshotMessage = (
    <div className="u-small-spacing-top">
      <SnapshotIcon snapshot={snapshot} className="icon u-small-spacing-right text-center" />
      <SnapshotText snapshot={snapshot} />
    </div>
  );
  if (snapshot.url) {
    return <a href={snapshot.url}>{snapshotMessage}</a>;
  }
  return snapshotMessage;
}

SnapshotInfo.propTypes = {
  snapshot: SNAPSHOT_PROPS.isRequired,
};
